import "../assets/styles/Footer.css";

const Footer = () => {


  return (
      <>
        <div className="footer-wrapper">
            <a href="#" target="_blank" rel="noreferrer">Designed and built by Elmo</a>
        </div>
      </>
  );
};

export default Footer;